import { FaPlus } from "react-icons/fa";
import { MdOutlineWifiTethering } from "react-icons/md";
import { RiSimCard2Line } from "react-icons/ri";
import { TbDeviceSim2 } from "react-icons/tb";
import ButtonElement from "../../../Common/ButtonElement";
import InputElement from "../../../Common/InputElement";

const InventoryItem = ({ inventoryType, isAisType, onChangeHandler, addItems, gpsImeiNo, simStatus, gpsImeiNoErr, simImeiNo, simImeiNoErr, simNum, simNumErr, simIccidNo, simIccidNoErr, simTwoNum, simTwoNumErr, isCompleted }) => {
    return <div className="row align-items-start">
        <div className={`col-lg-${isCompleted ? "12" : "11"}`}>
            <div className="row">
                {inventoryType != 3 ? <div className={`col-lg-${inventoryType > 1 ? "12" : isAisType ? "3" : "4"} mb-2`}>
                    <InputElement
                        label={"GPS IMEI no."}
                        placeholder={"Enter GPS IMEI no."}
                        name={"gpsImeiNo"}
                        value={gpsImeiNo}
                        error={gpsImeiNoErr}
                        icon={<MdOutlineWifiTethering size={20} />}
                        onChange={onChangeHandler}
                    />
                </div> : null}
                {inventoryType != 2 ? <div className={`col-lg-${inventoryType > 1 ? simStatus != "Blank" ? "6" : "12": isAisType ? "3" : "4"} mb-2`}>
                    <InputElement
                        label={isAisType ? "SIM ICCID no." : "SIM IMEI No."}
                        placeholder={isAisType ? "Enter SIM ICCID no." : "Enter SIM IMEI No."}
                        name={"simImeiNo"}
                        value={simImeiNo}
                        error={simImeiNoErr}
                        icon={<RiSimCard2Line size={20} />}
                        onChange={onChangeHandler}
                    />
                </div> : null}
                {(inventoryType != 2 && simStatus != "Blank") ? <div className={`col-lg-${inventoryType > 1 ? "6" : isAisType ? "3" : "4"} mb-2`}>
                    <InputElement
                        type="phone"
                        label={`SIM Number ${isAisType ? "1" : inventoryType != 3 ? "(optional)" : ""}`}
                        placeholder={"Enter SIM Number"}
                        name={"simNum"}
                        value={simNum}
                        error={simNumErr}
                        icon={<TbDeviceSim2 size={20} />}
                        onChange={onChangeHandler}
                    />
                </div> : null}
                {(isAisType || simTwoNum) ? <div className={`col-lg-3 mb-2`}>
                    <InputElement
                        type="phone"
                        label={`SIM Number 2`}
                        placeholder={"Enter SIM Number"}
                        name={"simTwoNum"}
                        value={simTwoNum}
                        error={simTwoNumErr}
                        icon={<TbDeviceSim2 size={20} />}
                        onChange={onChangeHandler}
                    />
                </div> : null}
            </div>
        </div>
        {/* {(isAisType || (simIccidNo && simTwoNum)) ? <div className={`col-lg-${isCompleted ? "12" : "11"}`}>
            <div className="row">
                <div className={`col-lg-6 mb-2`}>
                    <InputElement
                        type="phone"
                        label={`SIM ICCID no. 2`}
                        placeholder={"Enter SIM ICCID no."}
                        name={"simIccidNo"}
                        value={simIccidNo}
                        error={simIccidNoErr}
                        icon={<RiSimCard2Line size={20} />}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className={`col-lg-4 mb-2`}>
                    <InputElement
                        type="phone"
                        label={`SIM Number 2`}
                        placeholder={"Enter SIM Number"}
                        name={"simTwoNum"}
                        value={simTwoNum}
                        error={simTwoNumErr}
                        icon={<TbDeviceSim2 size={20} />}
                        onChange={onChangeHandler}
                    />
                </div>
            </div>
        </div> : null} */}
        {!isCompleted ? <div className="col-lg-1 text-center">
            <ButtonElement text={<FaPlus size={"16px"} />} cssClass="small-radius plus-btn" onClick={addItems} variant="btn-outline-primary" />
        </div> : null}
    </div>
}

export default InventoryItem;